<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  name: 'App',
  mounted(){
    var _this = this
        window['backManual'] = (e) => {
            _this.backManual(e)
        }
  },
  methods: {
    // 退出项目
        backManual(urlVal) {
          console.log('news返回',urlVal)
           if (urlVal.includes('user') || urlVal.includes('hide') || urlVal.includes('score') || urlVal.includes('newsDetails') || urlVal.includes('comIntroduction') || urlVal.includes('agreement') ) {
                window.WeiKangYunShang.jsClosePage()
            } else {
                this.$router.go(-1)
            }
        }
  }
}
</script>
<style>
</style>
